import React from 'react';
import PageTitle from '../../layouts/PageTitle';
import '../../../scss/pages/_university-list.scss'

const University = () => {
    return (
        <div className='university'>
            
            <PageTitle
                title="University"
                subtitle="university"
            />

            <div className="row mt-5">
                <div className="col-md-4 col-lg-4">
                    <div className=" d-flex justify-content-between left-side">
                        <b>Welcome to foodpanda!</b> 
                        <i className='mdi mdi-chevron-right'> </i>
                    </div>
                    <div className="d-flex left-side justify-content-between mt-1">
                        <b>Introduction to Restaurant Portal</b>
                        <i className='mdi mdi-chevron-right'> </i>
                    </div>
                    <div className="d-flex justify-content-between left-side mt-1">
                        <b>Reports In Restaurant Portal</b>
                        <i className='mdi mdi-chevron-right'> </i>
                    </div>
                    <div className="d-flex justify-content-between left-side mt-1">
                        <b>Menu Management</b>
                        <i className='mdi mdi-chevron-right'> </i>
                    </div>
                    <div className=" d-flex justify-content-between left-side mt-1">
                        <b>Photo Guidelines & Tips</b>
                        <i className='mdi mdi-chevron-right'> </i>
                    </div>
                    <div className=" d-flex justify-content-between left-side mt-1">
                        <b>Grow your business!</b>
                        <i className='mdi mdi-chevron-right'> </i>
                    </div>
                    <div className="card-header rounded-0 d-flex left-side-text mt-1">
                        <span>Make use of this tools to grow and scale your business with trackable result</span>
                    </div>
                    <div className="d-flex justify-content-between left-side mt-1">
                        <b>Vendor Performance!</b>
                        <i className='mdi mdi-chevron-right'> </i>
                    </div>
                </div>
                <div className="col-md-8 col-lg-8">
                    <div className="card rounded-0">
                        <div className="card-body right-side">
                            <b className='fs-5'>Welcome to foodpanda!</b>
                            <p className='mt-2 mb-0'>Dearest Partner </p>
                              <p className='mt-2 mb-0'>
                                Welcome to foodpanda! We hope you're excited to begin our journey with us. Here you'll find everything you need to get started on our platform. Learn how to set up and make use of the device handle incoming orders, and manage your restaurant and menu through our portals.
                            </p>
                            <p className='mt-2'>Lets get started! The guides below with take you through:-Setting up of your goDroid device-How to handle and process your incoming orders-Managing the operational timing and restaurant menu.
                            </p>
                            
                            <div className="row">
                                <div className="col-md-4 col-lg-4">
                                        <div className="d-flex right-side-file align-items-center">
                                        <i className='mdi mdi-file-outline mdi-24px'> </i>
                                             <div className='d-grid ml-3'>
                                                <b>Download PDF</b> 
                                                <small>Welcome to foodpand? </small>
                                             </div>
                                    </div>
                                    <div className="d-flex right-side-file align-items-center mt-2">
                                        <i className='mdi mdi-file-outline mdi-24px'> </i>
                                        <div className='d-grid ml-3'>
                                            <b>Download PDF</b>
                                            <small>Processing Orders? </small>
                                        </div>
                                    </div>
                                    <div className="d-flex right-side-file align-items-center mt-2">
                                        <i className='mdi mdi-file-outline mdi-24px'> </i>
                                        <div className='d-grid ml-3'>
                                            <b>Download PDF</b>
                                            <small>Manage Restaurant and Menu? </small>
                                        </div>
                                    </div>
                                </div>
                             </div>

                         </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default University;